import { FunctionComponent as F, ReactElement } from "react";
import TextTooltip from "./TextTooltip";
import { TooltipPlacement } from "../../../core/types/component";




interface IProps
{
  children: ReactElement;
  showtooltip: boolean;
  lines: string[];
  tooltipPlacement?: TooltipPlacement;
}


const TextTooltipOpt: F<IProps> = (props: IProps) =>
{
  return(props.showtooltip ?
    <TextTooltip
      tooltipPlacement={props.tooltipPlacement}
      children={props.children}
      lines={props.lines}/> :
    props.children);
};

export default TextTooltipOpt;
